import { FilePlusIcon } from './FilePlusIcon';

/**
 * author: Simran
 * id 9C42F83F-4C75-4E0A-A1C2-F10FA032E495
 * name file-plus
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-plus.svg
 * tags
 * - Files / Folders 
 */
export const NoteAddIcon = FilePlusIcon;
export default NoteAddIcon